import { z } from 'zod';

// Date format: YYYY-MM-DD
export const DateStringSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD format');

// Enums
export const RoleSchema = z.enum(['SUPER_ADMIN', 'ADMIN', 'STAFF']);
export const ProductCategorySchema = z.string().min(1).max(50);
export const QualityLevelSchema = z.enum(['LOW', 'MEDIUM', 'HIGH', 'PREMIUM']);
export const StrainTypeSchema = z.enum(['INDICA', 'SATIVA', 'HYBRID', 'CBD']);
export const CountTypeSchema = z.enum(['MORNING', 'EVENING']);
export const VarianceStatusSchema = z.enum(['ACCEPTABLE', 'WARNING', 'CRITICAL']);

// Product validation
export const CreateProductSchema = z.object({
  name: z.string().min(1).max(255),
  category: ProductCategorySchema,
  quality: QualityLevelSchema.optional(),
  strainType: StrainTypeSchema.optional(),
  unitSize: z.number().min(0),
  unitType: z.string(),
  pricePerUnit: z.number().min(0).optional(), // Optional - for internal reference only
  minStock: z.number().min(0),
  maxStock: z.number().min(0),
  currentStock: z.number().min(0).optional(),
  isAccumulating: z.boolean().optional(), // Products like STEMS that can exceed morning count
  isActive: z.boolean().optional(), // false for historical-only products
});

export const UpdateProductSchema = CreateProductSchema.partial().extend({
  id: z.string().cuid(),
});

// Stock Count validation
export const RecordCountSchema = z.object({
  counts: z.array(z.object({
    productId: z.string().cuid(),
    quantity: z.number().min(0),
    type: CountTypeSchema,
    date: DateStringSchema,
    notes: z.string().optional(),
    performedBy: z.string().optional(),
  })),
  metadata: z.object({
    isEdit: z.boolean().optional(),
    reason: z.string().optional(),
    originalCount: z.any().optional(),
  }).optional(),
});

// Sale validation
export const RecordSaleSchema = z.object({
  productId: z.string().cuid(),
  quantity: z.number().min(0),
  totalAmount: z.number().min(0).optional(), // Optional - quantity tracking only
  notes: z.string().optional(),
  performedBy: z.string().optional(),
  date: DateStringSchema.optional(), // YYYY-MM-DD format - uses selected date or defaults to now()
});

// ReUp validation
export const RecordReUpSchema = z.object({
  productId: z.string().cuid(),
  quantity: z.number().min(0),
  notes: z.string().optional(),
  performedBy: z.string().optional(),
  date: DateStringSchema.optional(), // YYYY-MM-DD format - uses selected date or defaults to today
});

// Business validation
export const CreateBusinessSchema = z.object({
  name: z.string().min(1).max(255),
});

export const JoinBusinessSchema = z.object({
  code: z.string().length(6),
});

// User validation
export const UpdateUserSchema = z.object({
  firstName: z.string().min(1).optional(),
  lastName: z.string().optional(),
  username: z.string().optional(),
});

